import { Injectable, inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { HelperService } from "@shared/services/helper.service";
import { AppConstants } from "@core/constants";

@Injectable()
export class DevelopmentOnlyGuardService {
  private router: Router = inject(Router);
  private helperService: HelperService = inject(HelperService);

  public canActivate(): boolean {
    const isDevelopmentEnvironment: boolean =
      this.helperService.isDevelopmentEnvironment(
        location,
        AppConstants.ENVIRONMENT_URL.DEV,
      );
    const isLocalEnvironment: boolean = this.helperService.isLocalEnvironment(
      location,
      AppConstants.ENVIRONMENT_URL.LOCAL,
    );
    const isSecureLocalEnvironment: boolean =
      this.helperService.isLocalEnvironment(
        location,
        AppConstants.ENVIRONMENT_URL.SECURE_LOCAL,
      );

    if (
      isDevelopmentEnvironment ||
      isLocalEnvironment ||
      isSecureLocalEnvironment
    ) {
      return true;
    } else {
      this.router.navigateByUrl("/home/dashboard");
      return false;
    }
  }
}

export const DevelopmentOnlyGuard: CanActivateFn = (): boolean => {
  return inject(DevelopmentOnlyGuardService).canActivate();
};
